import axios from 'axios'
// import jsonp from 'jsonp'
import { func } from '../firebase'

export default {
  install (Vue, options) {
    function axiosReq (request, callback) {
      console.log(request.url)
      axios(request).then(function (response) {
        console.log(response)
        callback(response.data)
      }).catch(function (error) {
        callback({ Success: false, Data: error })
      })
    }

    Vue.prototype.$GetInstallers = function (installerRootAddress, authKey, callback) {
      var query = '?AuthKey=' + authKey
      var req = {
        url: installerRootAddress + query,
        method: 'get',
        responseType: 'json'
      }

      axiosReq(req, function (response) {
        callback(response)
      })
    }

    Vue.prototype.$Login = function (username, password, callback) {
      var user = {
        userId: 0,
        isActive: true,
        username: username,
        password: password
      }
      var query = '?method=Login&input=' + JSON.stringify(user)
      var req = {
        url: this.$root.config.apiUrl + query,
        method: 'get',
        responseType: 'json'
      }

      axiosReq(req, function (response) {
        callback(response)
      })
    }

    Vue.prototype.$AllPrinters = function (callback) {
      var query = '?method=GetAllPrinters&input='
      var req = {
        url: this.$root.config.apiUrl + query,
        method: 'get',
        responseType: 'json'
      }

      axiosReq(req, function (response) {
        callback(response)
      })
    }

    Vue.prototype.$UpdateCounters = function (countersData, callback) {
      var updateCountersFunc = func.httpsCallable('UpdateCounters')
      updateCountersFunc(countersData).then((result) => {
        callback(result)
      }).catch((error) => {
        callback(error)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/api.js